import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { RouterModule } from '@angular/router';

import { JYoguiSharedModule } from '../shared';

// ag-grid
import {AgGridModule} from '@ag-grid-community/angular';

import { USERS_FINANTIAL_STATUS_REPORT_ROUTE, UsersFinantialStatusReportComponent } from './';

@NgModule({
    imports: [
        JYoguiSharedModule,
        AgGridModule.withComponents([]),
        RouterModule.forRoot([USERS_FINANTIAL_STATUS_REPORT_ROUTE], { useHash: true })
    ],
    declarations: [
        UsersFinantialStatusReportComponent,
    ],
    entryComponents: [
    ],
    providers: [
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class JYoguiUsersFinantialStatusReportModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/users-finantial-status-report/users-finantial-status-report-component.module.ts